// Module
var code = "<contract-detail-wrapper contract=\"masterAgreementDetailController.contract\" contract-type=\"masterAgreementDetailController.contractType\" sensitive-info-permission=\"'contractSensitiveInfo'\"> </contract-detail-wrapper> ";
// Exports
export default code;